module.exports = __webpack_public_path__ + "img/BFSPORTSBOOK.2eeb7fbe.svg";